import Image from 'next/legacy/image';
import logo1 from '../../public/assets/images/shaking_logo2-01.jpg';
import logo2 from '../../public/assets/images/shaking_logo2-02.jpg';
import image1 from '../../public/assets/images/shakingcrabNewton 1.jpg';

import styles from './shakeAround.module.css';

const ShakeAroundContent = () => (
  <div className={styles.app__shake_around_container}>
    <div className={styles.app__shake_around_wrapper}>
      <div className={styles.app__shake_around_text_n_image}>
        <div className={styles.app__shake_around_text}>
          <p>
            {/* eslint-disable-next-line max-len */}
            Shaking Crab&apos;s vision for messy eatin&apos; began with the core belief that food can be more than sustenance, but an experience to be shared with those around us. Bibs up, phones down, we need YOUR help to continue spreading the communal experience of shaking.
          </p>
          <p>
            {/* eslint-disable-next-line max-len */}
            Show us where you&apos;ve been spreading the shake and tag us on Instagram @shakingcrab
          </p>
        </div>
        <div className={styles.app__shake_around_image}>
          <div>
            <Image
              src={logo1} objectFit={`cover`}/>
          </div>
          <div>
            <Image
              src={logo2} objectFit={`cover`}/>
          </div>
          <div className={styles.app__shake_around_introduction}>
            <span>Design by Boston based Artist Hayato J. Kawai</span>
          </div>
        </div>
      </div>
      <div>
        <div>
          <Image
            src={image1} layout={`responsive`}/>
        </div>
        <div className={styles.app__shake_around_introduction}>
          <span>
                Sketch by Boston-based artist Mike Daikubara: @mikedaikubara
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default ShakeAroundContent;
